import api from './base/standardApi';

const DocsRequestTemplatesApi = {
  getTemplates( params?: any ) {
    return api.get( 'api/plantillasolicitud/GetAll', params );
  },
  createTemplate( data:any ) {
    return api.post( 'api/plantillasolicitud/Create/', data );
  },
  editTemplate( templateId: number, data:any ) {
    return api.put( `api/plantillasolicitud/Update/${templateId}`, data );
  },
  deleteTemplate( eventId: number ) {
    return api.delete( `api/plantillasolicitud/Delete/${eventId}` );
  },
};

export default DocsRequestTemplatesApi;
